import styled from 'styled-components';
import RadioGroup from '../RadioGroup';
import Badge from '../Badge';

export const Row = styled.div`
  margin-bottom: 24px;
`;

export const StyledLabel = styled.div`
  margin-bottom: 16px;
  font-size: 12px;
  font-weight: 500;
`;

export const ImportOptionsRadioGroup = styled(RadioGroup)`
  flex-direction: column;
  align-items: flex-start;
  row-gap: 10px;
  margin-bottom: 24px;
`;

export const HorizontalField = styled.div<{ isEnabled: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 8px;
  opacity: ${({ isEnabled }) => (isEnabled ? 1 : 0.3)};
`;

export const StyledBadge = styled(Badge)`
  margin-left: 8px;
`;
